//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HeadNavigation',
  props: {
    title: {          // 标题栏居中标题
      type: String,
      default: ''
    },
    rightTitle: {     // 标题栏右边文字
      type: String,
      default: ''
    },
    leftTitle: {     // 标题栏左边文字
      type: String,
      default: 'back'
    },
    showLeftIcon: {
      type: Boolean,
      default: true
    },
    isBlue: {
      type: Boolean,
      default: false
    },
    hasNoBd: {
      type: Boolean,
      default: false
    },
    isRightBlue: {
      type: Boolean,
      default: false
    },
    isAllShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showInner: true
    }
  },
  methods: {
    // 返回键功能
    leftBtn () {
      this.$emit('leftBtn')
    },
    // 右边文字点击事件
    rightBtn () {
      this.$emit('rightBtn')
    }
  },
  computed: {
    showSelf () {
      let ret = true
      if (this.isAllShow) {
        return true
      }
      if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
        ret = window.__wxjs_environment !== 'miniprogram'
      }
      return ret
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/head-navigation.vue